import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PlusIcon } from "@heroicons/react/24/outline";
import classNames from "../../../helpers/classNames";
import { useEditor } from "../../../hooks/EditorProvider";
import { v4 as uuidv4 } from "uuid";
const RepeatItem = ({ children, repeatId, elementProps, elementId, create, className, editable, component: Component = "div", ...props }) => {
    const { updateElementProp } = useEditor();
    const handleCreate = () => {
        const propData = elementProps?.[repeatId]?.items || [];
        propData.push(uuidv4());
        updateElementProp({ items: propData }, repeatId, elementId);
    };
    if (editable) {
        return (_jsxs(Component, { className: classNames("relative border border-dashed p-1", className), "editor-repeatid": repeatId, ...props, children: [children || null, create && (_jsx("div", { className: "group relative mt-2 flex cursor-pointer items-center justify-center border border-dashed p-2", onClick: handleCreate, children: _jsx("div", { className: "bg-app-600 hover:bg-app-700 flex h-6 w-6 items-center justify-center rounded-lg p-1 text-white", children: _jsx(PlusIcon, { className: "h-4 w-4" }) }) }))] }));
    }
    return _jsx(Component, { className: className, children: children || null });
};
export default RepeatItem;
//# sourceMappingURL=RepeatItem.js.map